/* eslint-disable react-hooks/exhaustive-deps */
import { faCirclePlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FieldArray, FormikProps, getIn, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";

import { OnlineGamingOptions } from "../../../../config/filingConstants";
import { IOtherIncomes } from "../../../../config/interfaces";
import FASvgIcon from "../../../FASvgIcon";
import PreventEditComponent from "../../../PreventEditComponent";
import PriceDisplay from "../../../PriceDisplay";
import { NumericInputField, SelectInputField, TextInputField } from "../../../fields";

const OIAnyIncomeFromOnlineGamingForm: React.FC = () => {
  const { values } = useFormikContext<IOtherIncomes>();

  const [sum, setSum] = useState(0);
  const [inputTotal, setInputTotal] = useState<{ [key: string]: number }>({});
  const [currentTime, setCurrentTime] = useState<number>(new Date().getTime());

  useEffect(() => {
    let _sum = 0;
    let _totalInput: { [key: string]: number } = {};
    if (values?.AnyOnlineGaming?.length) {
      values?.AnyOnlineGaming.forEach((item, index) => {
        _totalInput[index] = parseInt(item[1]) || 0;
        if (item.length && item[1]) {
          _sum += parseInt(item[1]) || 0;
        }
      });
      setInputTotal(() => _totalInput);
    }
    setSum(() => _sum);
  }, [currentTime]);

  const handleAmountInc = (amt: number, index: string) => {
    inputTotal[index] = amt;
    setInputTotal(() => inputTotal);
    const _sum = Object.values(inputTotal).reduce((a, b) => Number(a) + Number(b), 0);
    setSum(() => _sum);
  };

  return (
    <section className="mb-5">
      <div className="section-title-wrap">
        <h5>
          Online Gaming, Lottery, Gifts and more
          <small>
            Income from Lottery Winnings, Games, Crossword Puzzles, Horse Races, Gambling, Betting
            and more under Section 115BB
          </small>
        </h5>
      </div>
      <Card className="more-info-card shadow-none">
        <Card.Header>
          <Card.Title>Gaming, Lottery, Gifts and more</Card.Title>
        </Card.Header>
        <Card.Body>
          <section>
            <FieldArray name="AnyOnlineGaming">
              {({ push, replace, remove, form }) => (
                <>
                  {values?.AnyOnlineGaming && values?.AnyOnlineGaming?.length > 0
                    ? values?.AnyOnlineGaming.map((_, index) => (
                        <section className="mb-3 mb-sm-0" key={`any-other-in-${index}`}>
                          <OtherIncomeForm
                            index={index}
                            form={form}
                            onRemove={(itemIdx: number) => {
                              if (values.AnyOnlineGaming.length === 1) {
                                replace(itemIdx, ["", "", ""]);
                              } else {
                                remove(itemIdx);
                              }

                              setCurrentTime(new Date().getTime());
                            }}
                            handleAmountInc={handleAmountInc}
                          />
                        </section>
                      ))
                    : null}
                  <PreventEditComponent>
                    <Button
                      variant="link"
                      className="btn-add-link"
                      onClick={() => push(["", "", ""])}
                    >
                      <FASvgIcon icon={faCirclePlus} />
                      Add more
                    </Button>
                  </PreventEditComponent>
                </>
              )}
            </FieldArray>
          </section>
        </Card.Body>
        <Card.Footer>
          <p className="total-content">
            <span className="total-label">Total:</span>
            <span className="total-amount">
              <PriceDisplay price={sum} />
            </span>
          </p>
        </Card.Footer>
      </Card>
    </section>
  );
};

export default OIAnyIncomeFromOnlineGamingForm;

type OIFormProps = {
  index: number;
  form: FormikProps<IOtherIncomes>;
  onRemove: (itemIdx: number) => void;
  handleAmountInc: (amt: number, index: string) => void;
};

const OtherIncomeForm: React.FC<OIFormProps> = (props: OIFormProps) => {
  const { index, onRemove, form, handleAmountInc } = props;

  const { setFieldValue, handleBlur, values, touched, errors } = form;

  return (
    <>
      <Row className="align-items-center">
        <Col sm={4}>
          <SelectInputField
            label="Source"
            placeholder="Select source"
            isOptionArrayOfObject={false}
            name={`AnyOnlineGaming.${index}.[0]`}
            options={OnlineGamingOptions}
            value={[values.AnyOnlineGaming[index]?.[0]] || ""}
            onChange={(selectedOption) => {
              if (selectedOption) {
                setFieldValue(`AnyOnlineGaming.${index}.[0]`, selectedOption.value);
              } else {
                setFieldValue(`AnyOnlineGaming.${index}.[0]`, undefined);
              }
            }}
            onBlur={handleBlur(`AnyOnlineGaming.${index}.[0]`)}
            isInvalid={
              Boolean(getIn(errors, `AnyOnlineGaming.${index}.[0]`)) &&
              getIn(touched, `AnyOnlineGaming.${index}.[0]`)
            }
            errorMsg={getIn(errors, `AnyOnlineGaming.${index}.[0]`)}
          />
        </Col>
        <Col sm>
          <TextInputField
            name={`AnyOnlineGaming.${index}.[2]`}
            label="Description"
            value={values.AnyOnlineGaming[index]?.[2] || ""}
            onChange={(value) => setFieldValue(`AnyOnlineGaming.${index}.[2]`, value)}
            onBlur={(e) => {
              handleBlur(e);
              setFieldValue(
                `AnyOnlineGaming.${index}.[2]`,
                values.AnyOnlineGaming[index]?.[2].trim()
              );
            }}
            isInvalid={
              Boolean(getIn(errors, `AnyOnlineGaming.${index}.[2]`)) &&
              getIn(touched, `AnyOnlineGaming.${index}.[2]`)
            }
            errorMsg={getIn(errors, `AnyOnlineGaming.${index}.[2]`)}
          />
        </Col>
        <Col sm>
          <NumericInputField
            showLeftIcon={true}
            name={`AnyOnlineGaming.${index}.[1]`}
            label="Amount"
            value={values.AnyOnlineGaming[index]?.[1] || ""}
            onBlur={handleBlur(`AnyOnlineGaming.${index}.[1]`)}
            onChange={(value) => {
              setFieldValue(`AnyOnlineGaming.${index}.[1]`, value);
              setTimeout(() => {
                handleAmountInc(Number(value), String(index));
              }, 100);
            }}
            isInvalid={
              Boolean(getIn(errors, `AnyOnlineGaming.${index}.[1]`)) &&
              getIn(touched, `AnyOnlineGaming.${index}.[1]`)
            }
            errorMsg={getIn(errors, `AnyOnlineGaming.${index}.[1]`)}
          />
        </Col>
        <PreventEditComponent>
          <Col sm={"auto"} className="ps-0">
            <Button
              variant="transparent"
              className="text-greyDark icon-only d-none d-sm-flex"
              onClick={() => onRemove(index)}
            >
              <FASvgIcon icon={faTrash} />
            </Button>
            <Button
              variant="transparent"
              className="btn-delete-full d-sm-none"
              onClick={() => onRemove(index)}
            >
              <FASvgIcon icon={faTrash} />
              <span>Delete</span>
            </Button>
          </Col>
        </PreventEditComponent>
      </Row>
      {index !== values.AnyOnlineGaming.length - 1 && <hr className="d-block d-sm-none my-4" />}
    </>
  );
};
